module.exports = __webpack_public_path__ + "static/media/button.fa7d7a36.svg";